import { service } from '.';

export default {
  getAll: (data) => service.post('/categories/filter', data),
  getSpecialCategories: () => service.get('/categories/specialGet'),
  getAllByGroups: () => service.post('/plans/category'),
  importants: () => service.get('/importants'),
  addImportant: (data) => service.post('/importants', data),
  updateImportant: (id, data) => service.put(`/importants/${id}`, data),
  getOne: (id) => service.get(`/categories/${id}`),
  create: (data) => service.post(`/categories`, data),
  createSpecial: (data) => service.post('/categories/special', data),
  update: (id, data) => service.put(`/categories/${id}`, data),
  delete: (id) => service.delete(`/categories/${id}`),
  deleteImportant: (data) =>
    service.delete('/importants', {
      data,
    }),
};
